import {updateVariableTokens} from "./enhanced-editor/base";
import {resizeIframe} from "./main";
import {translate} from "./functions";
import {cityZipcode} from "./city-zipcode";

export function handleChangeAnswer() {

    let leadForm = $('#leadForm');
    if (leadForm.length === 0) {
        return;
    }
    let leadAnswerContent = $('#lead_answerContent');
    if (leadAnswerContent.length > 0) {
        leadForm.on('change', ':input', function () {
            if ($(this).attr('id') !== 'lead_answerContent') {
                updateVariableTokens();
            }
            if ($(this).attr('id') === 'lead_customer_title') {
                const noteContent = $('#lead_note_content');
                if ($(this).prop('checked')) {
                    // femme
                    noteContent.val(noteContent.val().replace(/Le client/g, "La cliente"))
                } else {
                    // homme
                    noteContent.val(noteContent.val().replace(/La cliente/g, "Le client"))
                }
            }
        });
        $('#lead_customer_title').trigger('change');
    }
}

export function changeEmailFormat() {
    $('.change-format input').unbind('change').on('change', function() {
        let section = $(this).parents('.section');
        if ($(this).prop('checked')) {
            section.find('.--plain').removeClass('--hidden');
            section.find('.--html').addClass('--hidden');
        } else {
            section.find('.--html').removeClass('--hidden');
            section.find('.--plain').addClass('--hidden');
            setTimeout(resizeIframe, 100);
        }
    });
}

export function duplicateEmails() {
    const $anchors = $('.data-anchors');
    const $dataBlocksContainer = $('.data-blocks');
    const $dataBlocks = $('.data-block');
    const totalBlocks = $dataBlocks.length;

    let currentIndex = 0;

    // Définir la largeur de chaque bloc dynamiquement
    $dataBlocks.each(function() {
        $(this).css('flex', `0 0 ${100 / totalBlocks}%`);
    });

    // Définir la largeur totale du wrapper
    $dataBlocksContainer.css('width', `${100 * totalBlocks}%`);

    // Fonction pour actualiser le slider
    function updateDataBlock(index) {
        if (index < 0) index = 0;
        if (index >= totalBlocks) index = totalBlocks - 1;

        // Translation dynamique en pourcentage
        $dataBlocksContainer.css('transform', `translateX(-${(100 / totalBlocks) * index}%)`);

        // Met à jour la classe active sur l'ancre
        const targetId = $dataBlocks.eq(index).data('id');
        const targetNb = $dataBlocks.eq(index).data('nb');
        $('.item').removeClass('--active');
        $(`.item[data-id="${targetId}"]`).addClass('--active');

        let title = translate('crm.common.email');
        if (targetNb !== 1) {
            title += ' ' + targetNb;
        }

        $('#emailTitle').text(title);

        // Ajuste la hauteur des data-blocks
        $dataBlocks.each(function(i) {
            if (i === index) {
                $(this).removeClass('--height0').addClass('--visible');
            } else {
                $(this).removeClass('--visible').addClass('--height0');
            }
        });

        currentIndex = index;
    }


    // Navigation avec "next"
    $anchors.find('.next').on('click', function() {
        currentIndex = (currentIndex + 1) % totalBlocks;
        updateDataBlock(currentIndex);
    });

    // Navigation avec "prev"
    $anchors.find('.prev').on('click', function() {
        currentIndex = (currentIndex - 1 + totalBlocks) % totalBlocks;
        updateDataBlock(currentIndex);
    });

    // Navigation avec les ancres
    $anchors.find('.item').on('click', function() {
        const targetId = $(this).data('id');
        const $targetBlock = $dataBlocks.filter(`[data-id="${targetId}"]`);
        if ($targetBlock.length) {
            const targetIndex = $dataBlocks.index($targetBlock);
            updateDataBlock(targetIndex);
        }
    });

    // Initialisation
    updateDataBlock(currentIndex);
}



$(function () {
    cityZipcode($('.collection-item.property'))
})